import cx from 'classnames';
import React from 'react';
import styles from './NoResults.mscss';

interface OwnProps {
    message: React.ReactNode;
    detailMessage?: string;
    className?: string;
    noIcon?: boolean;
}

const NoResults: React.StatelessComponent<OwnProps> = ({ noIcon, message, className, detailMessage }) => (
    <div className={cx(styles.NoResults, className)}>
        {!noIcon && (
            <div className={styles.NoResults__icon}>
              <i className="fa fa-search" />
            </div>
        )}
        <div className={styles.NoResults__message}>
            {message}
        </div>
        {detailMessage && (
            <div className={styles.NoResults__detail_message}>
                {detailMessage}
            </div>
        )}
    </div>
);

export default NoResults;
